/**
 * Morpho Chat streaming WebSocket via nginx → Daphne (/ws/).
 * Same-origin so nginx can upgrade the connection (see devops/config/nginx/nginx-local.conf).
 * Caller falls back to HTTP poll if WS fails.
 */

const morphoChatWsUrl = () => {
	const wsPrefix = window.location.protocol === "https:" ? "wss" : "ws";
	// Prefer nginx-proxied /ws/ on the page host (port 80/443). Direct :8003 only as last resort
	// when the app is opened on a non-proxied port (e.g. webpack dev) and nginx is not in path.
	const host = window.location.host; // hostname[:port]
	const port = window.location.port;
	if (!port || port === "80" || port === "443") {
		return `${wsPrefix}://${host}/ws/slide_ai/`;
	}
	// Dev: hit Daphne directly when not behind nginx
	return `${wsPrefix}://${window.location.hostname}:8003/ws/slide_ai/`;
};

/**
 * Subscribe to a Morpho Chat job stream.
 * @returns {{ close: () => void }}
 */
export const subscribeMorphoChatJob = ({jobId, slideId, onDelta, onDone, onError}) => {
	let closed = false;
	let sock = null;
	try {
		sock = new WebSocket(morphoChatWsUrl());
	} catch (e) {
		onError?.(e);
		return {close: () => {}};
	}

	const close = () => {
		closed = true;
		try {
			sock?.close();
		} catch (_) { /* ignore */ }
	};

	sock.onopen = () => {
		if (closed) return;
		sock.send(JSON.stringify({op: "subscribe", job_id: jobId, slide_id: slideId}));
	};

	sock.onmessage = (ev) => {
		if (closed) return;
		let data;
		try {
			data = JSON.parse(ev.data);
		} catch (_) {
			return;
		}
		if (data.op === "delta") {
			onDelta?.(data);
		} else if (data.op === "done") {
			onDone?.(data);
			close();
		} else if (data.op === "error") {
			onError?.(data);
			close();
		}
	};

	sock.onerror = () => {
		if (!closed) onError?.({message: "WebSocket error"});
	};

	sock.onclose = () => {
		/* caller handles fallback if done never arrived */
	};

	return {close};
};

export default subscribeMorphoChatJob;
